'use strict';

export default [
  {
    name: 'fb',
    url: 'https://www.facebook.com/showaroundcom'
  },
  {
    name: 'instagram',
    url: 'https://instagram.com/showaroundcom'
  },
  {
    name: 'twitter',
    url: 'https://twitter.com/showaroundcom'
  },
  {
    name: 'youtube',
    url: 'https://www.youtube.com/channel/UC3KXWGyos-5HVAUo5tnuH-A'
  },
  {
    name: 'vimeo',
    url: 'https://vimeo.com/showaround'
  }
];



// WEBPACK FOOTER //
// ./app/src/common/social_links/social_links.constant.js